import { API } from 'aws-amplify';

class uploadedFilesSservice {
  getFiles = async (airlineCode) => {
    var ReturnObj = [];
    await API.get('IAPI', 'UploadFile/uploadedFiles/', {
      'queryStringParameters': {
        'AirlineCode': airlineCode
      }
    }).then((res) => {
      ReturnObj = res;
      return res;
    }).catch((error) => {
      return error;
    });
    return ReturnObj;

  }

  uploadFile = async (formData) => {
    var ReturnObj = {};

    const API_INIT = {
      body: formData
    }   
    
    await API.post('IAPI', 'UploadFile/uploadFile/', API_INIT)
      .then((res) => {
        ReturnObj = res;
        return res;
      })
      .catch((error) => {
        return error;
      });
    return ReturnObj;

  }
}

export default new uploadedFilesSservice();